import script from "./LastOrdered.vue?vue&type=script&setup=true&lang=js"
export * from "./LastOrdered.vue?vue&type=script&setup=true&lang=js"

import "./LastOrdered.vue?vue&type=style&index=0&id=51890198&lang=scss"

const __exports__ = script;

export default __exports__